import { useEffect, useState } from "react";
import { useSeenAllNotification, useSeenNotification } from "../Hooks";
import { useTheme } from "@mui/material";

const useDashboardLogic = (data, userId) => {
  const theme = useTheme().palette.mode;

  const headerBoxStyle = {
    display: "flex",
    overflowX: "auto",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: `1px solid ${theme === "dark" ? "#353841" : "#EDEDEF"}`,
    bgcolor: theme === "dark" ? "#1E232D" : "#F7FBFF",
    padding: "0.5rem 4px",
    margin: 0,
  };
  const [renderNotifcation, setRenderNotifcation] = useState(10);
  const [typeCount, setTypeCount] = useState({
    all: 0,
    misc: 0,
    scheduler: 0,
    orders: 0,
    customer: 0,
    personCartable: 0,
  });
  const typeHandler = (type) => {
    setRenderNotifcation(type);
  };

  const typeCounthandler = (data) => {
    if (!data) return;
    const count = {
      all: data.length,
      misc: data.filter((item) => item.category == 0).length,
      scheduler: data.filter((item) => item.category == 1).length,
      orders: data.filter((item) => item.category == 2).length,
      customer: data.filter((item) => item.category == 3).length,
      personCartable: data.filter((item) => item.category == 4).length,
    };
    setTypeCount(count);
  };

  const { mutate } = useSeenNotification();
  const { mutate: removeAllMessage } = useSeenAllNotification();
  //*Seen Message Handler
  const seenMessage = (id) => {
    mutate(id);
  };
  //*Seen All Message Handler
  const seenAllMessage = () => {
    removeAllMessage(userId);
  };
  useEffect(() => {
    if (!data) return;
    typeCounthandler(data);
  }, [data]);

  return {
    state: {
      renderNotifcation,
      typeCount,
      headerBoxStyle,
    },
    action: {
      typeHandler,
      seenMessage,
      seenAllMessage,
    },
  };
};

export default useDashboardLogic;
